import React, {CSSProperties, ReactNode, useState} from "react";
import {Alert, Button} from "antd";
import * as styles from "./Tip.module.css";
import {loadLocalStorageValue, saveLocalStorageValue} from "../../sal-ui/PersistentStorage";

const ITEM_PATH = "Seal.Tips";
const LEGACY_ITEM_PATH = "Seal.Tip";

type Props = {
    id: string;
    message: ReactNode;
    description?: ReactNode;
    className?: string;
    style?: CSSProperties;
};

function Tip(props: Props) {
    const [show, setShow] = useState(() => !loadTips()[props.id]);

    if (!show) {
        return null;
    }

    const className = props.className
        ? `${styles.tip} ${props.className}`
        : styles.tip;

    return (
        <div className={className} style={props.style}>
            <Alert
                type="info"
                showIcon={true}
                title={props.message}
                description={
                    <>
                        {props.description &&
                            <div className={styles.description}>
                                {props.description}
                            </div>
                        }
                        <div className={styles.actions}>
                            <Button type="link" size="small" style={{padding: 0}} onClick={onClose}>
                                Hide this tip permanently
                            </Button>
                        </div>
                    </>
                }
            />
        </div>
    );

    function onClose() {
        const tips = loadTips();

        tips[props.id] = true;

        saveLocalStorageValue(ITEM_PATH, JSON.stringify(tips), LEGACY_ITEM_PATH);
        setShow(false);
    }

    function loadTips(): Record<string, boolean> {
        const tips = loadLocalStorageValue(ITEM_PATH, LEGACY_ITEM_PATH);

        if (tips === null) {
            return {};
        }

        return JSON.parse(tips);
    }
}

export default Tip;
